export default `
  .c-n {
    margin: 0;
    padding: 0;
    border: 0;
    box-shadow: none;
  }
`;
